import ShopCarAnimation from "./index.vue";
import Vue, {VueConstructor} from "vue";
import {mergeOptions} from "@/core/plugin_helper";

let $vm: any

const install = (vue: VueConstructor, options = {}, targetDom?: string) => {
    let AnimationConstructor = vue.extend(ShopCarAnimation)
    
    if (!$vm) {
        $vm = new AnimationConstructor({
            el: document.createElement('div'),
            propsData: {
                title: ''
            }
        })
        document.body.appendChild($vm.$el)
    }
    const value = {
      show (option: any, targetDom?: string) {
        $vm.shopCarAnimation(option, targetDom)
      }
    }
    Object.defineProperty(vue.prototype, '$shopCarAnimation', {
        value: value
    })
}

Vue.use(install)

export default install
